<template>
    <nav aria-label="pagination">
        <ul class="pagination  justify-content-center">
            <li class="page-item">
                <a @click.prevent="changePage(1)" :disabled="pagination.current_page <= 1" aria-label="Primera página" href="#" target="_self" class="page-link">«</a>
            </li>
            <li class="page-item">
                <a @click.prevent="changePage(pagination.current_page - 1)" :disabled="pagination.current_page <= 1" aria-label="Página anterior" href="#" target="_self" class="page-link">‹</a>
            </li>
            <li role="separator" class="page-item disabled">
                <span class="page-link">…</span>
            </li>
            <li class="page-item" :class="isCurrentPage(page) ? 'active' : ''" v-for="(page,i) in pages" v-bind:key="i">
                <a @click.prevent="changePage(page)" aria-label="Go to page 3" href="#" target="_self" class="page-link c-page-link-number"> {{ page }} </a>
            </li>
            <li role="separator" class="page-item disabled">
                <span class="page-link">…</span>
            </li>
            <li class="page-item">
                <a @click.prevent="changePage(pagination.current_page + 1)" :disabled="pagination.current_page >= pagination.last_page" aria-label="Página siguiente" href="#" target="_self" class="page-link">›</a>
            </li>
            <li class="page-item">
                <a @click.prevent="changePage(pagination.last_page)" :disabled="pagination.current_page >= pagination.last_page" aria-label="Última página" href="#" target="_self" class="page-link">»</a>
            </li>
        </ul>
    </nav>
</template>
<script>
    export default {
        props: ['pagination', 'offset'],
        methods: {
            isCurrentPage(page) {
                return this.pagination.current_page === page;
            },
            changePage(page) {
                if (page > this.pagination.last_page) {
                    page = this.pagination.last_page;
                }
                this.pagination.current_page = page;
                this.$emit('paginate', this.pagination.current_page);
            }
        },
        computed: {
            pages() {
                let pages = [];
                let from = this.pagination.current_page - Math.floor(this.offset / 2);
                if (from < 1) {
                    from = 1;
                }
                let to = from + this.offset - 1;
                if (to > this.pagination.last_page) {
                    to = this.pagination.last_page;
                }
                while (from <= to) {
                    pages.push(from);
                    from++;
                }
                return pages;
            }
        }
    }
</script>
